import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ColorOptions, HorizontalAlignmentOptions } from '@df/ui/atomic/atomic-options';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
export interface IPageComponentIndexedTextItem {
    isRegularLink: boolean;
    url: string;
    title: string;
    anchorId: string;
    text_position?: string;
}
export interface IPageComponentIndexedTextData extends NICmsContentComponent.IData {
    items?: IPageComponentIndexedTextItem[];
    font_color?: string;
    position: string;
}
@ICmsComponent<PageComponentIndexedTextComponent>({
    id: 'indexed-text',
    name: 'Indexed Text',
    tags: ['links'],
    fields: [
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'items',
            title: 'Item',
            itemName: 'item',
            defaultSize: 2,
            fields: [
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.toggle,
                    key: 'isRegularLink',
                    title: 'Regular Link',
                    default: false
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'url',
                    title: 'Regular Link URL',
                    required: true,
                    canShow: data => data.isRegularLink
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'title',
                    title: 'Title',
                    required: true
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'anchorId',
                    title: 'Anchor ID',
                    reqiuired: true,
                    canShow: data => !data.isRegularLink
                }
            ]
        },
        <NICmsContentField.IColorPickerField>{
            key: 'font_color',
            type: NICmsContentField.EFieldType.colorPicker,
            title: 'Font Colour',
            options: ColorOptions,
            colorPreview: true
        },
        <NICmsContentField.IChoiceField>{
            key: 'position',
            type: NICmsContentField.EFieldType.choice,
            title: 'Position',
            options: HorizontalAlignmentOptions,
            default: 'center'
        }
    ]
})
@Component({
    selector: 'page-component-indexed-text',
    templateUrl: './indexed-text.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, SizeClassDirective, HrefComponent]
})
export class PageComponentIndexedTextComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentIndexedTextData;
}
